import Glide from '@glidejs/glide'
import Indicators from '@components/sliders/indicators'

window.Glide = Glide
window.Indicators = Indicators